import PropTypes from "prop-types";
import { Link as RouterLink } from "react-router-dom";
import useGetLogo from "./hooks/use-logo";

const Logo = ({ disabledLink = false }) => {
  const logo = useGetLogo() || "/juenesse-logo.jpeg";

  if (disabledLink) {
    return (
      <img
        style={{ width: "150px", height: "auto", maxHeight: "64px" }}
        src={logo}
        alt="logo"
      />
    );
  }

  return (
    <RouterLink to="/">
      <img style={{ width: "150px", height: "auto" }} src={logo} alt="logo" />
    </RouterLink>
  );
};

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default Logo;
